// src/pages/CheckAPI.jsx
import React from "react";

const CheckAPI = () => {
  return (
    <div style={{ padding: 40 }}>
      <h1>API URL usada en frontend:</h1>
      <p>{process.env.REACT_APP_API_URL || "No definida"}</p>
    </div>
  );
};

export default CheckAPI;
